/* jshint esnext: true */
import AbstractModule from './AbstractModule';
import { $document, APP_NAME, DATA_API_KEY } from '../utils/environment';
import Scrollbar from 'smooth-scrollbar';

const DATA_KEY  = `${APP_NAME}.select`;
const EVENT_KEY = `.${DATA_KEY}`;


/**
 * Button
 */
export default class extends AbstractModule
{
    constructor(options)
    {
        super(options);

        this.hasSmoothScrollbar = false;
        this.$select = this.$el.find('.js-select');
        this.$select.selectric({
            onInit: () => this.initScrollbar(),
            onRefresh: () => this.updateScrollbar()
        });
    }

    initScrollbar() {
        if (!window.isIos && window.innerWidth > 1024) {
            this.scrollbar = Scrollbar.init(this.$el.find('.selectric-scroll')[0], { alwaysShowTracks: true });
            this.hasSmoothScrollbar = true;
        }
    }

    updateScrollbar() {
        if (this.hasSmoothScrollbar) {
            this.scrollbar.update();
        }
    }

    destroy()
    {
        this.$el.off(EVENT_KEY);
    }
}


